import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { EnrollmentType } from './enrollmentService';

export interface Policy {
  id: string;
  pdfs: File[];
  outputFiles: File[];
  generationStep: GenerationStep;
  group: Group;
  enrollmentPeriod: EnrollmentPeriod;
  creationDate: string;
  agency: Agency;
  sequentialGroupId?: string;
  sequentialProductLineIds?: Record<string, string>;
  productOutputs: FileInfo[];
  filesFromDocx: File[];
  additionalOutputsZip?: File;
  finalZip?: File;
  finalCsvZip: File;
}

export interface FileInfo {
  link: string;
  name: string;
  type: FileType;
  creationDate: string;
}

export enum FileType {
  BENEFIT_SUMMARY = 'BENEFIT_SUMMARY',
  PRODUCT_JSON = 'PRODUCT_JSON',
  BENEFIT_SUMMARY_ZIP = 'BENEFIT_SUMMARY_ZIP',
  PRODUCT_JSON_ZIP = 'PRODUCT_JSON_ZIP',
}

export interface EnrollmentPeriod {
  id: string;
  effectiveDate: string;
  domainId: string;
  type: EnrollmentType;
}

export interface Agency {
  general: boolean;
  tin: string;
  name: string;
  npn: string;
}

export interface Group {
  id: string;
  name: string;
  carrierGroupNumber?: string;
}

export interface File {
  id: string;
  name: string;
  creationDate: string;
  status: PdfResultV2Status;
  signatureRequestDate: string;
}

export interface EDateZipInfo {
  effectiveDate: string;
  zipId: string;
  zipName: string;
}

export interface GroupInfo {
  groupName: string;
  groupId: string;
  agencyName: string;
  aorName: string;
  submittedBy: string;
  effectiveDate: string;
  productLine: ProductLineId[];
  submittedDate: string;
}

export enum GenerationStep {
  INACTIVE_POLICY = 'INACTIVE_POLICY',
  OUTPUT_GENERATION_FAILED = 'OUTPUT_GENERATION_FAILED',
  NOT_STARTED = 'NOT_STARTED',
  GROUP_FILES_GENERATED = 'GROUP_FILES_GENERATED',
  MAINTENANCE_FILES_GENERATED = 'MAINTENANCE_FILES_GENERATED',
  EDI_GENERATION_READY = 'EDI_GENERATION_READY',
  EDI_GENERATED = 'EDI_GENERATED',
  MEMBER_CARD_GENERATION_READY = 'MEMBER_CARD_GENERATION_READY',
  COMPLETED = 'COMPLETED',
}

export enum PdfResultV2Status {
  SIGNATURE_PENDING,
  COMPLETED,
}
